(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bn-state-variant-pair"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bn-state-variant-slider')) {
    customElements.define(
      'bn-state-variant-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.bn-state-variants__track');
          this.items = [...this.querySelectorAll('.bn-state-variants__item')];
          this.dots = [...this.querySelectorAll('.bn-state-variants__dot')];
          this.frame = null;
          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.updateActiveDot();
            });
          };
          this.track?.addEventListener('scroll', this.onScroll, { passive: true });
          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => {
              const item = this.items[Number(dot.dataset.slideIndex)];
              if (!item || !this.track) return;
              this.track.scrollTo({
                left: item.offsetLeft,
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              });
            });
          });
        }

        disconnectedCallback() {
          this.track?.removeEventListener('scroll', this.onScroll);
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        updateActiveDot() {
          if (!this.track || !this.items.length) return;
          const index = this.items.reduce((closest, item, itemIndex) => {
            const currentDistance = Math.abs(item.offsetLeft - this.track.scrollLeft);
            const closestDistance = Math.abs(this.items[closest].offsetLeft - this.track.scrollLeft);
            return currentDistance < closestDistance ? itemIndex : closest;
          }, 0);
          this.dots.forEach((dot, dotIndex) => {
            const active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            if (active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
